import { render, staticRenderFns } from "./PoliticaPrivacidadeSeguranca.vue?vue&type=template&id=33f33d18"
import script from "./PoliticaPrivacidadeSeguranca.vue?vue&type=script&lang=js"
export * from "./PoliticaPrivacidadeSeguranca.vue?vue&type=script&lang=js"
import style0 from "./PoliticaPrivacidadeSeguranca.vue?vue&type=style&index=0&id=33f33d18&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports